/* @flow */
export default {
  PUSH: '@NAZOTOKI_BINGO/ROUTER/PUSH',
};



// WEBPACK FOOTER //
// ./src/core/router/actionTypes.js